var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bar"},[_c('div',{staticClass:"barleft"},[_c('span',{class:['icon-dot','bg-'+ _vm.bgcolor]}),_vm._t("default",function(){return [_vm._v("导航")]})],2),_vm._t("barright")],2)}
var staticRenderFns = []

export { render, staticRenderFns }